import { AngleBoldLeft16, AngleBoldRight16 } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { Button } from '@elfsight/widget-ui';
import { COLOR_TRANSPARENT } from '@elfsight/widget-ui/src/button/constants';
import { useSettings } from '@wu/widget-core';

type NavigationButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  direction: 'backward' | 'forward';
  ariaLabel?: string;
};

export function NavigationButton({
  onClick,
  direction,
  disabled,
  ariaLabel
}: NavigationButtonProps) {
  const { textColor } = useSettings();

  return (
    <Button
      aria-label={ariaLabel}
      iconOnly
      fontColor={textColor}
      color={COLOR_TRANSPARENT}
      borderColor={COLOR_TRANSPARENT}
      overlayVariants={{
        hover: { backgroundColor: getColorWithAlpha(textColor, 0.1) },
        tap: { backgroundColor: getColorWithAlpha(textColor, 0.1) }
      }}
      variants={{
        hover: { borderColor: COLOR_TRANSPARENT },
        tap: { borderColor: COLOR_TRANSPARENT }
      }}
      borderRadius={8}
      horizontalPadding={8}
      verticalPadding={8}
      disabled={disabled}
      onClick={onClick}
    >
      {direction === 'forward' && (
        <Icon size={16} fill={textColor} component={AngleBoldRight16} />
      )}
      {direction === 'backward' && (
        <Icon size={16} fill={textColor} component={AngleBoldLeft16} />
      )}
    </Button>
  );
}
